module.exports = __webpack_public_path__ + "img/dashboards-ar.14e632dc.png";